import { apiRequest } from "../lib/apiClient";

export interface AutoSubmissionSettings {
  enabled: boolean;
  effectiveEnabled: boolean;
  operatorConfigured: boolean;
  supportedAdapters: string[];
  reason: string | null;
  enableConfirmation: string;
}

export interface AutomationGateway {
  getSettings(): Promise<AutoSubmissionSettings>;
  setEnabled(
    enabled: boolean,
    confirmationText?: string,
  ): Promise<AutoSubmissionSettings>;
}

export const automationGateway: AutomationGateway = {
  getSettings() {
    return apiRequest<AutoSubmissionSettings>("/automation/settings");
  },

  setEnabled(enabled, confirmationText = "") {
    return apiRequest<AutoSubmissionSettings>("/automation/settings", {
      method: "PUT",
      body: JSON.stringify({ enabled, confirmationText }),
    });
  },
};
